import { ToDoPageSize } from '@opsbase/lib-data-query/consts';
import { default as QueryFieldKey } from '@opsbase/lib-data-queryfield/QueryFieldKey';
import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import AppPage from '@opsbase/web-app/AppPage';
import ButtonCard from '@opsbase/web-cards/ButtonCard';
import DataTreeController from '@opsbase/web-ctrl-datatree/DataTreeController';
import useView from '@opsbase/web-ctrl-view/useView';
import useViewActions from '@opsbase/web-ctrl-view/useViewActions';
import DVLCardStack from '@opsbase/web-dvl-cardstack';
import DVLTable from '@opsbase/web-dvl-table';
import DVLToolbar from '@opsbase/web-dvl-toolbar';
import AddIcon from '@opsbase/web-icons/icons/AddIcon';
import ListRoundedIcon from '@opsbase/web-icons/icons/ListRoundedIcon';
import ViewCardsIcon from '@opsbase/web-icons/icons/ViewCardsIcon';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import ActionButton from '@opsbase/web-ui/ActionButton';
import Fab from '@opsbase/web-ui/Fab';
import React, { useCallback, useMemo, useState } from 'react';
import IssueToDoCard from '../cards/IssueToDoCard';
import IssueMenu from '../menus/IssueMenu';
export function IssuesToDoPage() {
    const { goTo } = useNav();
    const self = useSelf();
    const { filters } = useView(DataType.ISSUE_TODO);
    const { setBooleanFilter } = useViewActions(DataType.ISSUE_TODO);
    const [tableView, setTableView] = useState(false);
    const isShowingMineOnly = !!filters.find(f => f.queryFieldKey === QueryFieldKey.SHOW_MINE_ONLY && f.id === 'TRUE');
    const isShowingCreated = !!filters.find(f => f.queryFieldKey === QueryFieldKey.ISSUE_CREATED_BY_ME && f.id === 'TRUE');
    const handleClickCreate = useCallback(() => {
        goTo(Pages.ISSUE_CREATE);
    }, [goTo]);
    const handleClickShowMineOnly = useCallback(() => {
        setBooleanFilter(QueryFieldKey.SHOW_MINE_ONLY, !isShowingMineOnly);
    }, [isShowingMineOnly, setBooleanFilter]);
    const handleClickShowCreated = useCallback(() => {
        setBooleanFilter(QueryFieldKey.ISSUE_CREATED_BY_ME, !isShowingCreated);
    }, [isShowingCreated, setBooleanFilter]);
    const handleToggleTableView = useCallback(() => setTableView(!tableView), [tableView]);
    const additionalMoreButtons = useMemo(() => {
        let v = [];
        if (isShowingMineOnly)
            v = [
                ...v,
                React.createElement(ActionButton, { key: "incCreated", big: true, highlight: isShowingCreated, onClick: handleClickShowCreated, label: i18n.t('inc-created') }),
            ];
        if (!self.isEmployee && !self.isTeamboard)
            v = [
                ...v,
                React.createElement(ActionButton, { key: "yourIssues", big: true, highlight: isShowingMineOnly, onClick: handleClickShowMineOnly, label: i18n.t('your-issues') }),
            ];
        v = [
            ...v,
            React.createElement(ActionButton, { key: "showTable", disabled: tableView, highlight: tableView, onClick: handleToggleTableView, Icon: ListRoundedIcon, label: 'Table' }),
            React.createElement(ActionButton, { key: "showCards", disabled: !tableView, highlight: !tableView, onClick: handleToggleTableView, Icon: ViewCardsIcon, label: 'Cards' }),
        ];
        return v;
    }, [
        isShowingMineOnly,
        isShowingCreated,
        handleClickShowCreated,
        self,
        handleClickShowMineOnly,
        handleToggleTableView,
        tableView,
    ]);
    return (React.createElement(AppPage, null,
        React.createElement(DataTreeController, { pageSize: ToDoPageSize, viewId: DataType.ISSUE_TODO },
            React.createElement(Vertical, { gutter: true, style: { overflow: 'hidden' } },
                React.createElement(Pane, { padding: true },
                    React.createElement(DVLToolbar, { disableFieldSelection: true, additionalMoreButtons: additionalMoreButtons })),
                !tableView && (React.createElement(DVLCardStack, { itemComponent: IssueToDoCard, beforeComponent: React.createElement(ButtonCard, { icon: React.createElement(AddIcon, { size: 80 }), label: i18n.t('raise-an-issue'), onClick: handleClickCreate }), notFoundText: i18n.t('issues-empty') })),
                tableView && (React.createElement(Pane, { grow: true, padding: true },
                    React.createElement(DVLTable, { selectable: false, itemPage: Pages.ISSUES_VIEW, itemMenu: IssueMenu, notFoundText: i18n.t('issues-empty') }),
                    React.createElement(Fab, { onClick: handleClickCreate })))))));
}
export default IssuesToDoPage;
